module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Barang")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/barang_jadi"
    }
  }, [_vm._v("Barang Jadi")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("BARANG JADI")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.tableData1,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "#",
      "header-align": "center",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.edit) ? [_vm._v("\n                            " + _vm._s(scope.row.no) + ".\n                          ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "NAMA",
      "prop": "nama",
      "header-align": "left",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Barang Jadi"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariNama()
            }
          },
          model: {
            value: (_vm.cari_nama),
            callback: function($$v) {
              _vm.cari_nama = $$v
            },
            expression: "cari_nama"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.nama))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "PREFIX",
      "prop": "prefix",
      "header-align": "left",
      "align": "left",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit) ? [_c('el-input', {
          attrs: {
            "placeholder": "Filter Prefix"
          },
          nativeOn: {
            "keyup": function($event) {
              return _vm.cariPrefix()
            }
          },
          model: {
            value: (_vm.cari_prefix),
            callback: function($$v) {
              _vm.cari_prefix = $$v
            },
            expression: "cari_prefix"
          }
        })] : _c('span', [_vm._v(_vm._s(scope.row.prefix))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PILIHAN",
      "align": "center",
      "header-align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ok",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-check"
          },
          on: {
            "click": function($event) {
              _vm.confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.confirmEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.edit1) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancel",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "el-icon-error",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.cancelEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Data",
      "visible": _vm.dialogFormVisible,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1), _vm._v(" "), (_vm.level.indexOf('ROOT') !== -1) ? _c('el-form-item', {
    attrs: {
      "label": "Prefix",
      "prop": "prefix"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.prefix),
      callback: function($$v) {
        _vm.$set(_vm.row1, "prefix", $$v)
      },
      expression: "row1.prefix"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Data",
      "visible": _vm.dialogFormEdit,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "nama"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    },
    model: {
      value: (_vm.row1.nama),
      callback: function($$v) {
        _vm.$set(_vm.row1, "nama", $$v)
      },
      expression: "row1.nama"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus data "), _c('b', [_vm._v(_vm._s(_vm.nama))]), _vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Informasi",
      "visible": _vm.dialogFormInfo,
      "width": "500px",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-717485b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/BarangJadi1.vue
// module id = 1405
// module chunks = 2